import { IkeHTTPStatus, type IkeRouteFieldMessage, type IkeRouteValidationResponse } from '@ikegps/core-api';

export enum IkeRequestErrorType {
	INVALID_SESSION = 'invalid_session',
	VALIDATION_FAILED = 'validation_failed',
	LICENSE_REQUIRED = 'license_required',
	UNKNOWN = 'unknown',
}

export class IkeRequestError extends Error {
	errors: IkeRouteFieldMessage[] = [];
	warnings: IkeRouteFieldMessage[] = [];
	info: IkeRouteFieldMessage[] = [];

	status: number;
	statusMessage: string;

	constructor(status: number, obj: IkeRouteValidationResponse) {
		super(`${status} ${obj.message}`);
		this.status = status;
		this.statusMessage = obj.message;
		if (obj.errors) {
			this.errors = obj.errors;
		}
		if (obj.warnings) {
			this.warnings = obj.warnings;
		}
		if (obj.info) {
			this.info = obj.info;
		}
	}

	static isIkeRequestError(e: any): e is IkeRequestError {
		return e && typeof e === 'object' && typeof e['status'] === 'number' && typeof e['statusMessage'] === 'string';
	}
}

export const IkeRequestErrorChecker = {
	getErrorType(requestError: IkeRequestError): IkeRequestErrorType {
		if (requestError == null) {
			return IkeRequestErrorType.UNKNOWN;
		}

		if (requestError.status === IkeHTTPStatus.VALIDATION_FAILED) {
			if (requestError.errors != null && requestError.errors.some((e) => e.field === 'token')) {
				return IkeRequestErrorType.INVALID_SESSION;
			}

			if (requestError.statusMessage === 'Validation failed') {
				return IkeRequestErrorType.VALIDATION_FAILED;
			}
		}

		if (requestError.status === IkeHTTPStatus.FORBIDDEN) {
			if (requestError.errors !== null && requestError.errors.some((e) => e.codes === 'license_required')) {
				return IkeRequestErrorType.LICENSE_REQUIRED;
			}
		}

		return IkeRequestErrorType.UNKNOWN;
	},
	isValidationFailed(requestError: IkeRequestError): boolean {
		const errorType = IkeRequestErrorChecker.getErrorType(requestError);
		return errorType === IkeRequestErrorType.VALIDATION_FAILED;
	},
	isLicenseRequired(requestError: IkeRequestError): boolean {
		const errorType = IkeRequestErrorChecker.getErrorType(requestError);
		return errorType === IkeRequestErrorType.LICENSE_REQUIRED;
	},
};
